import { BOOST_CATEGORY, TRIP_TYPE } from '@packages/types';
import {
  getBoostSelectedExtraCover,
  getMyHealthMandatoryBoost,
  getSelectedExtraCoverPrice,
  isBoostExtraCancellation,
} from '@packages/utils';

import { TripStore } from './trip.store';

export function addedSelectedCoverSelector(state: TripStore) {
  const extraCancellationBoost = state?.trip?.boosts?.find(isBoostExtraCancellation);
  const selectedExtraCover = getBoostSelectedExtraCover(extraCancellationBoost);
  return selectedExtraCover ?? null;
}

export function addedSelectedCoverPriceSelector(state: TripStore) {
  const extraCancellationBoost = state?.trip?.boosts?.find(isBoostExtraCancellation);
  return getSelectedExtraCoverPrice(extraCancellationBoost) as number;
}

export const getDestinationBackgroundImagesSelector = (state: TripStore) => {
  if (state.trip.destinations.length > 0) {
    return state.trip.destinations[0].imageLinks;
  } else {
    return {};
  }
};

export const getSelectedBoostById = (boostId?: string) => (state: TripStore) =>
  state?.trip?.boosts?.find(it => it.boostId === boostId);

export const getFilteredBoostsByCategorySelector =
  (boostCategory: BOOST_CATEGORY) => (state: TripStore) => {
    return state?.trip?.boosts?.filter(({ category }) => {
      return category === boostCategory;
    });
  };

export const selectedBoostsExcludingEMCCountSelector = (state: TripStore) =>
  state?.trip?.boosts?.filter(b => !b.isMandatory && b?.code !== 'EMC').filter(b => b.isAdded)
    .length;

export const allBoostExcludingEMCCountSelector = (state: TripStore) =>
  state?.trip?.boosts?.filter(b => !b.isMandatory && b?.code !== 'EMC').length;

export const getTripSelector = (state: TripStore) => state.trip;
export const tripStartDateSelector = (state: TripStore) => state.trip.startDate;
export const tripEndDateSelector = (state: TripStore) => state.trip.endDate;

export const tripTypeSelector = (state: TripStore) =>
  state?.trip?.tripType ?? TRIP_TYPE.INTERNATIONAL;

export const promoCodeSelector = (state: TripStore) => state?.trip?.promotionCode;

export const tripExcessAmountSelector = (state: TripStore) =>
  state?.trip?.metaData?.excessAmount ?? 0;

export const tripUserIdSelector = (state: TripStore) => state?.trip?.userId ?? '';

export const tripPrimaryTravellerSelector = (state: TripStore) => state?.trip?.primaryTraveller;

export function cruiseCoverBoostIdSelector(state: TripStore) {
  return state?.trip?.boosts?.find(it => it?.code === 'CRSF')?.boostId;
}

export const availableExcessLevelsSelector = (state: TripStore) => {
  const trip = state.trip;
  const mandatoryBoost = getMyHealthMandatoryBoost(trip);
  return mandatoryBoost?.boostProperty?.availableExcessLevels;
};

export const top3BoostHasBeenAddedSelector = (state: TripStore) => {
  return state?.trip?.boosts
    ?.filter(b => !b.isMandatory && b.code !== 'EMC')
    ?.slice(0, 3)
    ?.every(b => b.isAdded);
};
